// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c8f34310","239":"f0a2fdbe","667":"6393366a"}[chunkId] + ".chunk.js";
};